import Sqids from 'sqids';

const sqids = new Sqids({
  minLength: 6,
  alphabet: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
});

export function encodeReferralHash(userId: number): string {
  // Negative IDs (legacy Art Storefronts users) cannot be passed directly to
  // Sqids because it only supports non-negative integers. Represent them as a
  // two-element array [0, abs(id)] so the encoding is lossless and the decode
  // side can recover the exact original negative value for the DB lookup.
  if (userId < 0) {
    return sqids.encode([0, Math.abs(userId)]);
  }
  return sqids.encode([userId]);
}

export function decodeReferralHash(hash: string): number | null {
  if (!hash) return null;
  const decoded = sqids.decode(hash);

  // Single-element array: standard positive-ID encoding.
  if (decoded.length === 1) {
    const value = decoded[0];
    if (value === undefined) return null;
    return value;
  }

  // Two-element array starting with 0: negative legacy-ID encoding.
  if (decoded.length === 2 && decoded[0] === 0) {
    const absValue = decoded[1];
    if (absValue === undefined || absValue === 0) return null;
    return -absValue;
  }

  return null;
}
